export default {
  "title": {
    "traceability": "Trazabilidad faenas",
    "durationCharts": "Gráficos duración",
    "avgTimesHistogram": "Histograma tiempo en planta/cliente (minutos)",
    "avgTimesPerArrive": "Distribución de tiempos por hora de llegada separado por procesos"
  },
  "filters": {
    "startHour": "Hora inicio",
    "startHourOptions": {
      "": "Todas",
      "0;": "00:00 horas",
      "1;": "01:00 horas",
      "2;": "02:00 horas",
      "3;": "03:00 horas",
      "4;": "04:00 horas",
      "5;": "05:00 horas",
      "6;": "06:00 horas",
      "7;": "07:00 horas",
      "8;": "08:00 horas",
      "9;": "09:00 horas",
      "10;": "10:00 horas",
      "11;": "11:00 horas",
      "12;": "12:00 horas",
      "13;": "13:00 horas",
      "14;": "14:00 horas",
      "15;": "15:00 horas",
      "16;": "16:00 horas",
      "17;": "17:00 horas",
      "18;": "18:00 horas"
    },
    "waitingLength": "Duración",
    "waitingLengthOptions": {
      "": "Todas",
      "0;30": "0:30 minutos",
      "30;60": "30:60 minutos",
      "60;90": "60:90 minutos",
      "90;120": "90:120 minutos",
      "120;150": "120:150 minutos",
      "150;180": "150:180 minutos",
      "180;210": "180:210 minutos",
      "210;240": "210:240 minutos",
      "240;270": "240:270 minutos",
      "270;300": "270:300 minutos",
      "300;": "300+ minutos"
    }
  },
  "table": {
    "place": "Planta/Cliente",
    "vehicle": "Equipo",
    "from": "Desde",
    "to": "Hasta"
  },
  "labels": {
    "avgPerVehicle": "Promedio por equipo"
  },
  "graphTooltip": {
    "plantTime": "Tiempo en planta/cliente entre",
    "ocasion": "ocasiones",
    "minutes": "minutos",
    "proccess": "Proceso",
    "comingTime": "Hora llegada",
    "averageDuration": "Duración promedio",
    "arrivalTime": "Hora de llegada a planta/cliente"
  },
  "fufillment": {
    "acomplishment": "Cumplimiento de la ley",
    "bestPeriod": "mejora respecto al período anterior",
    "befor": "Período anteriror",
    "now": "Este Período",
    "howItGoes": "Como vas respecto a la meta",
    "goal": "Meta",
    "atRisk": "En riesgo",
    "operation": "Operación",
    "date": "Fecha",
    "break": "Descanso de 8 horas",
    "breakUnder": "Descanso bajo",
    "time": "horas",
    "amountOfBreak": "Cantidad de descanso",
    "amountOfUnacumplishment": "Cantidad de incumplimientos",
    "amountOfManagement": "Cantidad de gestiones",
    "seeDetail": "Ver detalle",
    "mainIndicator": "Principales indicadores",
    "manage": "Gestión",
    "fulfillment": "Cumplimiento",
    "unfulfillment": "incumplimiento",
    "homework": "Tarea",
    "homeworkInfo": "Información de la tarea",
    "_break": "Descanso",
    "driver": "Conductor",
    "type": "Tipo",
    "state": "Estado",
    "open": "Abiertas",
    "timeOfUnfufillment": "Fecha de incumplimiento",
    "expired": "Vencimiento",
    "initBreak": "Inicio descanso",
    "doneBreak": "Término descanso",
    "homeworkManagment": "Gestión de tarea",
    "reason": "Razón",
    "uploadFile": "Subir archivo",
    "placeholderText": "Escriba la razón por la que ocurrió este evento",
    "closeButton": "Cerrar desviación",
    "cancelButton": "Anular desviación",
    "driverRanking": "Ranking de conductores",
    "allIndicators": "Todos los indicadores",
    "title": "Principales indicadores",
    "titleSecond": "Principales indicadores",
    "categorie": "Categoría",
    "drivers": "Conductores",
    "evolution": "Evolución cumplimiento todas las operaciones",
    "operationIndicator": "Indicadores todas las operaciones"
  },
  "detailTruck": {
    "gravity": "Gravedad",
    "all": "Todas",
    "form": "Formulario",
    "empty": "Sin datos",
    "befor": "Período anterior",
    "to": "al",
    "driver": "Conductor",
    "team": "Equipo",
    "failsDetail": "Detalle fallas",
    "fails": "Fallas",
    "now": "Este periodo",
    "ranking": "Ranking",
    "inspections": "Inspecciones",
    "averageNote": "Nota promedio",
    "evolutionDay": "Evolucion diaria nota inspecciones"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/spanish/detail/detailWaitingTimes.js